export default __webpack_public_path__ + "images/ht-3af38bff509f443ef70e799f51a0e5c0.svg";